var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#62A9A9",
    x: 7,
    y: 0,
    width: 18,
    height: 18,
    rx: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6568542,20 L28.5648024,20 L32,22.1538462 L32,32 L16.9484863,32 L-0.0515136719,32 C-0.0515136719,32 -0.0515136719,28.7179487 -0.0515136719,22.1538462 L3.83402112,20 L10.3431458,20 L16,25.6568542 L21.6568542,20 Z",
    id: "Combined-Shape",
    fill: "#62A9A9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.91640ca0f8d9c7785c76ca1a8fab9b8a.svg";
export { ForwardRef as ReactComponent };